var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7075 11.7073L1.7075 21.7073C1.56765 21.8473 1.38939 21.9427 1.19531 21.9813C1.00122 22.02 0.800033 22.0002 0.61721 21.9244C0.434387 21.8487 0.278151 21.7204 0.16828 21.5558C0.0584092 21.3912 -0.000155428 21.1977 3.09801e-07 20.9998V0.999811C-0.000155428 0.801915 0.0584092 0.608423 0.16828 0.443829C0.278151 0.279235 0.434387 0.150941 0.61721 0.0751884C0.800033 -0.000564069 1.00122 -0.0203687 1.19531 0.0182817C1.38939 0.0569321 1.56765 0.1523 1.7075 0.292311L11.7075 10.2923C11.8005 10.3852 11.8742 10.4955 11.9246 10.6169C11.9749 10.7383 12.0008 10.8684 12.0008 10.9998C12.0008 11.1312 11.9749 11.2614 11.9246 11.3828C11.8742 11.5041 11.8005 11.6144 11.7075 11.7073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.47927dabf93a906bad48dec8399cf6bb.svg";
export { ForwardRef as ReactComponent };